// extracted by mini-css-extract-plugin
export var inner = "socials-module--inner--e445d";
export var socialItem = "socials-module--social-item--f7621";
export var socials = "socials-module--socials--02d02";